<template>
    <section>
        <pageHeader></pageHeader>
        <router-view></router-view>
        <pageFooter></pageFooter>
    </section>
</template>

<script>
    import '@/assets/css/app.scss';
    import pageHeader from '@/views/layout/pageHeader.vue';
    import pageFooter from '@/views/layout/pageFooter.vue';

    //window.document.body.onscroll = function () {
    //    document.body.className = document.body.scrollTop > 66 || document.documentElement.scrollTop > 66 ? "" : "noscroll";
    //};

    export default {
        name: 'routerPage',
        components: { pageHeader, pageFooter }
    };
</script>

<style>
</style>